import "./Vendors.scss";
import { useState, useEffect } from "react";
import PlusIcon from "../../../../../../utils/Images/PlusIcon";
import { useTranslation } from "react-i18next";
import { RightSidePanel, SourceCard } from "ui-components";
import VendorsDetails from "../VendorsDetails/VendorsDetails";
import { useParams } from "react-router-dom";
import { getJobPartnersList } from "../../../../../../service/StaffAugumentation/StaffAugumentationApis";
import { convertDate } from "../../../../../../utils/Common/Constant";

interface Partner {
  partnerCompanyId: string;
  partnerUserId: string;
  name: string;
  company: string;
  identifier: string;
  lastRefreshed: string;
  isActive: boolean;
  icon: string;
  location: string;
}
interface vendorProps {
  isInviteVendorOpen: boolean;
  setIsInviteVendorOpen: any;
  refreshSidebarVendors: any;
  setVendorTabId: any;
  setJobDetailsTab: any;
  totalCvListData: any;
  vendorCvCounts?: any[];
}
const Vendors = ({
  isInviteVendorOpen,
  setIsInviteVendorOpen,
  refreshSidebarVendors,
  setVendorTabId,
  setJobDetailsTab,
  vendorCvCounts,
}: vendorProps) => {
  const { jobId } = useParams();
  const { t } = useTranslation();
  const [vendorList, setVendorList] = useState<Partner[]>([]);
  const fetchVendors = async () => {
    try {
      const res = await getJobPartnersList(jobId);
      setVendorList(res.data.data);
    } catch (e: any) {
      console.error(e.message);
    }
  };
  useEffect(() => {
    if (jobId) {
      fetchVendors();
    }
  }, [jobId]);

  return (
    <>
      <div className="vendorList row">
        <div className="col-lg-6 col-xl-4">
          <div
            onClick={() => setIsInviteVendorOpen(true)}
            className="subVendor"
          >
            <PlusIcon color={"var(--light-grey)"} />
            <span>{t("RESUME.INVITE_VENDORS")}</span>
          </div>
        </div>
        {vendorList.map((item: any, ind: number) => {
          const fullName =
            item?.partnerUserDetails?.firstName ||
            item?.partnerUserDetails?.lastName
              ? item?.partnerUserDetails?.firstName +
                " " +
                item?.partnerUserDetails?.lastName
              : "-";
          const cvCount = vendorCvCounts?.find(
            (v) => v.partnerUserId === item?.partnerUserId,
          )?.cvCount;
          return (
            <div
              key={ind}
              className="vendorListItem col-lg-6 col-xl-4"
              onClick={() => {
                if (!cvCount || cvCount === 0) return;
                setVendorTabId(item?.partnerUserId);
                setJobDetailsTab("vendor");
              }}
            >
              <SourceCard
                index={ind}
                icon={item.partnerCompanyDetails?.logo}
                label={fullName || "-"}
                email={item.partnerCompanyDetails?.companyName}
                alias={item.partnerUserDetails?.email}
                dateTime={
                  item?.updatedAt
                    ? convertDate(item?.updatedAt, false, true)
                    : "-"
                }
                location={item.partnerCompanyDetails?.city}
              />
            </div>
          );
        })}
      </div>
      {isInviteVendorOpen && (
        <RightSidePanel
          show={true}
          handleClose={() => setIsInviteVendorOpen(false)}
          title={t("RESUME.INVITE_VENDORS")}
          className="addVendorModal"
        >
          <VendorsDetails
            goBack={() => setIsInviteVendorOpen(false)}
            fetchVendors={fetchVendors}
            refreshSidebarVendors={refreshSidebarVendors}
          />
        </RightSidePanel>
      )}
    </>
  );
};

export default Vendors;
